import { Apple, ArrowRight, Check, ScanLine, ShieldCheck, UsersRound } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

export function LoginPage() {
  const { user, loginApple, loginGoogle } = useAuth();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => { if (user) void navigate((location.state as { from?: string } | null)?.from ?? "/", { replace: true }); }, [location.state, navigate, user]);
  const run = async (login: () => Promise<void>) => { try { setError(""); await login(); } catch (cause) { setError(cause instanceof Error ? cause.message : "Sign-in failed"); } };
  return <main className="login-page">
    <section className="login-story">
      <div className="login-brand"><span className="brand-mark">S</span><span>Split Sh*t<small>by GhentiLabs</small></span></div>
      <div className="login-copy"><p className="eyebrow">THE NO-DRAMA LEDGER</p><h1>Split the bill.<br /><em>Keep the friends.</em></h1><p>Itemize every shared purchase, send each person exactly their part, and keep a clean history without moving any money.</p></div>
      <div className="receipt-demo" aria-hidden>
        <div className="receipt-top"><strong>Friday dinner</strong><span>$184.72</span></div>
        <div className="receipt-line"><span>Wood-fired pizza</span><span className="people-dots">● ● ●</span><b>$54.00</b></div>
        <div className="receipt-line"><span>Spicy rigatoni</span><span className="people-dots">● ●</span><b>$48.00</b></div>
        <div className="receipt-line"><span>Wine</span><span className="people-dots">● ● ● ●</span><b>$56.00</b></div>
        <div className="receipt-total"><span><Check size={16} /> Fully allocated</span><b>$184.72</b></div>
      </div>
      <div className="trust-row"><span><ScanLine /> Receipt OCR</span><span><UsersRound /> Exact item splits</span><span><ShieldCheck /> Private ledger</span></div>
    </section>
    <section className="login-panel">
      <div><p className="eyebrow">WELCOME IN</p><h2>Your shared tab,<br />finally organized.</h2><p>Use the same Ghenti account you already have.</p></div>
      <div className="login-actions">
        <button className="auth-button google" onClick={() => void run(loginGoogle)}><span>G</span>Continue with Google<ArrowRight /></button>
        <button className="auth-button apple" onClick={() => void run(loginApple)}><Apple fill="currentColor" />Continue with Apple<ArrowRight /></button>
        {error && <p className="form-error" role="alert">{error}</p>}
      </div>
      <p className="legal-copy">Split Sh*t records who owes what. It does not hold funds, connect to banks, or transfer money. By continuing, you agree to the <a href="/privacy">privacy notice</a>.</p>
    </section>
  </main>;
}
